var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCardStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 1.75v-.5c0-.138.049-.256.146-.354A.482.482 0 011.25.75h18.149c.138 0 .256.049.354.146a.482.482 0 01.146.354v26.866a.482.482 0 01-.146.354.482.482 0 01-.354.146H1.25a.482.482 0 01-.354-.146.482.482 0 01-.146-.354V1.75z",
    stroke: "#00B8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.772 8.733a.5.5 0 01.955 0l1.185 3.831a.5.5 0 00.478.352h3.883a.5.5 0 01.3.9l-3.18 2.43a.5.5 0 00-.175.545l1.206 3.9a.5.5 0 01-.78.545l-3.094-2.358a.5.5 0 00-.607 0l-3.085 2.36a.5.5 0 01-.78-.546l1.204-3.905a.5.5 0 00-.174-.545l-3.183-2.428a.5.5 0 01.3-.9h3.886a.5.5 0 00.478-.352l1.183-3.829z",
    stroke: "#FFF"
  }))));
}

export default SvgIconCardStar;